import { DownloadOutlined } from '@ant-design/icons'
import { Button, Dropdown } from 'antd'
import { FC } from 'react'
import downloadFileByBlob from '../../../helpers/download-file-by-blob'
import useBlankPreviewSelection from '../../../hooks/api/use-blank-preview-selection'
import useErrorModal from '../../../hooks/api/use-error-modal'
import {
    useLazyDownloadProductionBlankJpegQuery,
    useLazyDownloadShipmentBlankJpegQuery,
} from '../../../store/api/shipments-api'
import { BLANK_TYPE_BUTTON_COLOR, BLANK_TYPE_LABELS, ShipmentBlankType } from '../../../types/api/shipment-blank-type'
import UploadedFile from '../../../types/api/uploaded-file'
import { DocumentId } from '../../../types/strapi/strapi'

interface DownloadShipmentBlankProps {
    shipment: { documentId: DocumentId; id: number }
    blankType: ShipmentBlankType
    blankPreviewFiles?: UploadedFile[]
}

const DownloadShipmentBlank: FC<DownloadShipmentBlankProps> = ({
    shipment,
    blankType,
    blankPreviewFiles,
}) => {
    const [downloadClientBlank, clientBlankState] = useLazyDownloadShipmentBlankJpegQuery()
    const [downloadProductionBlank, productionBlankState] = useLazyDownloadProductionBlankJpegQuery()

    const downloadBlank = blankType === 'client' ? downloadClientBlank : downloadProductionBlank
    const downloadBlankState = blankType === 'client' ? clientBlankState : productionBlankState

    const label = BLANK_TYPE_LABELS[blankType]
    useErrorModal(downloadBlankState, `Ошибка скачивания ${label}`)

    const count = blankPreviewFiles?.length ?? 0
    const hasPreview = count > 0

    const onDownloadBlank = async (previewIndex: number) => {
        const res = await downloadBlank({ docId: shipment?.documentId || '', previewIndex })
        if (!res.data) return

        const filename =
            count > 1
                ? `${shipment.id}-${blankType}-${previewIndex + 1}.jpg`
                : `${shipment.id}-${blankType}.jpg`
        downloadFileByBlob(res.data, filename)
    }

    const { menuItems, runSingle } = useBlankPreviewSelection({
        blankPreviewFiles,
        onSelect: onDownloadBlank,
    })

    const loading = downloadBlankState.isLoading || downloadBlankState.isFetching

    const button = (
        <Button
            size={'small'}
            icon={<DownloadOutlined />}
            color={BLANK_TYPE_BUTTON_COLOR[blankType]}
            variant={'solid'}
            title={hasPreview ? `Скачать ${label}` : 'Превью ещё не загружено'}
            onClick={count > 1 ? undefined : () => void runSingle()}
            disabled={!hasPreview}
            loading={loading}
        />
    )

    if (count > 1) {
        return (
            <Dropdown menu={{ items: menuItems }} trigger={['click']}>
                {button}
            </Dropdown>
        )
    }

    return button
}

export default DownloadShipmentBlank
